/**
 * Restyles the Shopify Forms "10% off" teaser as a slim vertical tab on the right edge, with a small × above it.
 * The app draws the teaser inside its own (open) shadow root, so theme CSS can't reach it; we add a <style> there.
 * Only the teaser step is touched (the sign-up popup is unchanged). If the app's markup changes, the selectors
 * simply stop matching and the app's own teaser shows as before.
 */
(() => {
  const CSS = `
    #app-embed[data-current-step="tease"] { padding: 0 !important; }
    /* Phones: sit low on the right edge, clear of the hero's Shop button and the page content above the fold. */
    @media (max-width: 749px) {
      #app-embed[data-current-step="tease"] { top: auto !important; bottom: 88px !important; transform: none !important; }
    }
    #app-embed[data-current-step="tease"] [class*="_teaserContainer_"] {
      position: relative; overflow: visible; display: block; min-height: 0;
      padding: 18px 11px !important; margin: 0 !important;
      background: #4f6a12 !important; color: #fff !important;
      border: 0 !important; border-radius: 6px 0 0 6px !important; box-shadow: -2px 2px 10px rgb(0 0 0 / .18) !important;
      cursor: pointer;
    }
    #app-embed[data-current-step="tease"] [class*="_teaserHeading_"] {
      writing-mode: vertical-rl; transform: rotate(180deg);
      margin: 0 !important; padding: 0 !important; white-space: nowrap;
      color: #fff !important; font-size: 15px !important; font-weight: 600 !important; letter-spacing: .04em; line-height: 1 !important;
    }
    #app-embed[data-current-step="tease"] [class*="_teaserContainer_"] [class*="_formCloseButton_"] {
      position: absolute !important; top: -13px !important; left: -13px !important; right: auto !important; bottom: auto !important;
      width: 26px !important; height: 26px !important; padding: 0 !important; margin: 0 !important;
      display: flex !important; align-items: center; justify-content: center;
      background: #fff !important; color: #2a2a24 !important; border-radius: 50% !important;
      box-shadow: 0 1px 4px rgb(0 0 0 / .25) !important;
    }
    #app-embed[data-current-step="tease"] [class*="_formCloseButton_"] svg { width: 11px !important; height: 11px !important; }
  `;

  function style(root) {
    if (root.getElementById('tf-teaser-style')) return;
    const el = document.createElement('style');
    el.id = 'tf-teaser-style';
    el.textContent = CSS;
    root.appendChild(el);
  }

  function attach(host) {
    if (!host.shadowRoot) return false;
    style(host.shadowRoot);
    // Re-add if the app re-renders its shadow root.
    new MutationObserver(() => style(host.shadowRoot)).observe(host.shadowRoot, { childList: true });
    return true;
  }

  function scan() {
    for (const host of document.querySelectorAll('shopify-forms-embed:not([data-tf-styled])')) {
      if (attach(host)) host.dataset.tfStyled = '';
    }
  }

  // The app loads late (and may attach its shadow root after the element appears), so check for a while.
  scan();
  const timer = setInterval(scan, 500);
  setTimeout(() => clearInterval(timer), 30000);
})();
